module.exports = __webpack_public_path__ + "static/media/menu.a2ec4618.svg";